export default __webpack_public_path__ + "68a2cf96095f39b6b845c6fd7c063ade.svg";